// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Trash: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 60"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M16.6 50.9c.8 0 1.4-.6 1.4-1.4V19.4c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v30.2c0 .7.7 1.3 1.4 1.3zm10.7 0c.8 0 1.4-.6 1.4-1.4V19.4c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v30.2c0 .7.6 1.3 1.4 1.3z"/><path d="M41.5 8.2h-12V2.5c0-.8-.6-1.4-1.4-1.4H15.7c-.8 0-1.4.6-1.4 1.4v5.7H2.4c-.8 0-1.4.6-1.4 1.4S1.7 11 2.4 11h2.2v46.5c0 .8.6 1.4 1.4 1.4h31.9c.8 0 1.4-.6 1.4-1.4V11h2.2c.8 0 1.4-.6 1.4-1.4s-.7-1.4-1.4-1.4zM17.1 3.9h9.7v4.3h-9.7V3.9zm19.4 52.2H7.4V11h29.2v45.1z"/></svg>;
};

export default React.memo(Trash);
